import Modal from "react-bootstrap/Modal";
import React from "react";

const KitchenModal = ({
  show,
  onHide,
  id,
  selectedItem,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      backdrop={true}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="kitchen-modal"
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <div className="row mt-3 mb-3">
          <div className="col-6">مشتری: {selectedItem?.merchantName}</div>
          <div className="col-6 text-end">
            اشتراک: {selectedItem?.merchantCode}
          </div>
        </div>
        <b>اقلام سفارش</b>
        <table className="table table-striped table-md my-3">
          <thead className="align-middle">
            <tr>
              <th scope="col vertical-center" width="20px">
                ردیف
              </th>
              <th scope="col vertical-center">کد کالا</th>
              <th scope="col vertical-center">نام کالا</th>
              <th scope="col vertical-center" width="20px">
                تعداد
              </th>
            </tr>
          </thead>
          <tbody className="align-middle">
            {selectedItem?.invoiceItems
              .filter((p) => p.invoiceItemType === 1)
              .map((iitem, iindex) => (
                <tr key={iitem.id}>
                  <td>{iindex + 1}</td>
                  <td>{iitem.productCode}</td>
                  <td>{iitem.productName}</td>
                  <td>{iitem.amount}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </Modal.Body>
    </Modal>
  );
};

export default KitchenModal;
